// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import dynamicProto from "@microsoft/dynamicproto-js";
import { _throwInternal, isFunction } from "@microsoft/applicationinsights-core-js";
import { base64Decode, base64Encode } from "./Helpers/Utils";
import { _DYN_DATA, _DYN_IS_ARR, _DYN_TO_STRING } from "./__DynamicConstants";
var PayloadHelper = /** @class */ (function () {
    function PayloadHelper(logger) {
        dynamicProto(PayloadHelper, this, function (_self) {
            /**
             * Deserializes the current stringto a JSON object.
             */
            _self.base64ToArr = function (input) {
                if (!input || !input[_DYN_IS_ARR /* @min:%2eisArr */]) {
                    return input;
                }
                try {
                    var data = input[_DYN_DATA /* @min:%2edata */];
                    if (data) {
                        input[_DYN_DATA /* @min:%2edata */] = base64Decode(data);
                    }
                    return input;
                }
                catch (e) {
                    // if serialization fails return an empty string
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, (e && isFunction(e[_DYN_TO_STRING /* @min:%2etoString */])) ? e[_DYN_TO_STRING /* @min:%2etoString */]() : "Error serializing object", null, true);
                }
                return null;
            };
            _self.base64ToStr = function (item) {
                if (!item || !item[_DYN_IS_ARR /* @min:%2eisArr */]) {
                    return item;
                }
                try {
                    var data = item[_DYN_DATA /* @min:%2edata */];
                    if (data) {
                        item[_DYN_DATA /* @min:%2edata */] = base64Encode(data);
                    }
                    return item;
                }
                catch (e) {
                    // if serialization fails return an empty string
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, (e && isFunction(e[_DYN_TO_STRING /* @min:%2etoString */])) ? e[_DYN_TO_STRING /* @min:%2etoString */]() : "Error serializing object", null, true);
                }
                return null;
            };
        });
    }
    /**
     *  Decode the JSON string back to Uint8 array.
     */
    PayloadHelper.prototype.base64ToArr = function (input) {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
        return null;
    };
    /**
     * Code the Uint8 array object to string.
     */
    PayloadHelper.prototype.base64ToStr = function (item) {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
        return null;
    };
    return PayloadHelper;
}());
export { PayloadHelper };
//# sourceMappingURL=PayloadHelper.js.map